import React from 'react';
import { Counter, Divider, Footer, PriceTag, ProductInfo, Wrapper } from './form-product-info.styles';
import { Typography } from '@shared/ui/typography/typography';
import { RefundMoney } from '@vtbhome/juicyfront/indexIcon';
import { Button } from '@vtbhome/juicyfront';
import { FormProductInfoProps } from './types';
import { datePeriod, dateStart } from '@shared/lib/utils/date/date';
import { CACHE_KEY_BUY_ORDER } from '../../config/api-constants';
import { useBuyOrderMutation } from '../../api/buy-order-api';
import { productCountFromRequests } from '../../lib/utils/product-count-from-requests/product-count-from-requests';
import { floatNumber } from '@shared/lib/utils/float-number/float-number';
import { buyProductText } from '@shared/lib/utils/buy-product-text/buy-product-text';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { useCurrentOrganizationPreviewSharedQuery } from '@entities/organization/libs/hooks/use-current-organization-preview-shared-query/use-current-organization-preview-shared-query';
import { productPrice } from '@shared/lib/utils/product-price/product-price';

export const FormProductInfo: React.FC<FormProductInfoProps> = ({ order, handleSubmitRef }) => {
    const user = useCurrentUserSelector();

    const [, getCurrentOrganizationPreviewResult] = useCurrentOrganizationPreviewSharedQuery(user?.company?.id || 0);
    const currentOrganizationData = getCurrentOrganizationPreviewResult.data;

    const [, buyOrderResult] = useBuyOrderMutation({ fixedCacheKey: CACHE_KEY_BUY_ORDER });

    const product = order.product;
    const requestsCount = productCountFromRequests(order.requests);
    const priceProduct = Number(product?.price);
    const totalPrice = floatNumber(priceProduct * requestsCount);

    const handleSubmit = () => {
        const submit = handleSubmitRef.current;
        if (submit) {
            submit();
        }
    };

    return (
        <Wrapper>
            {product && (
                <ProductInfo>
                    <Typography size='h6'>{product.name}</Typography>
                    <Typography size='body1_long' color='neutral_50'>
                        {product?.endAt
                            ? datePeriod(product?.startAt || '', product?.endAt || '')
                            : dateStart(product?.startAt || '')}
                        {product?.place && ` · ${product.place}`}
                    </Typography>
                </ProductInfo>
            )}
            <Divider />
            <Counter>
                <Typography size='body1_long' color='neutral_50'>
                    Количество
                </Typography>
                <Typography size='h6'>{requestsCount}</Typography>
            </Counter>
            <Divider />
            <PriceTag>
                <Typography size='h3'>
                    {productPrice({
                        price: totalPrice,
                        withoutPrice: product.isPriceUndefined,
                    })}
                </Typography>
                <RefundMoney size='m' />
            </PriceTag>
            <Divider />
            <Footer>
                <Button
                    disabled={buyOrderResult.isLoading}
                    preloader={buyOrderResult.isLoading}
                    size='m'
                    onClick={handleSubmit}>
                    {buyProductText({
                        hasManager: Boolean(currentOrganizationData?.manager),
                        price: Number(product?.price),
                        productType: product?.type.code,
                        userRole: user?.role.code,
                        withoutPrice: product?.isPriceUndefined,
                    })}
                </Button>
            </Footer>
        </Wrapper>
    );
};
